const headerStyle = () => {
  if ($(window).scrollTop() > 10) {
    $('.header').addClass('header--shadow');
  } else {
    $('.header').removeClass('header--shadow');
  }

  if ($(window).scrollTop() > 350) {
    $('.header').addClass('header--scrolled');
  } else {
    $('.header').removeClass('header--scrolled');
  }
};

$(document).on('scroll', function () {
  headerStyle();
});

$(document).ready(function () {
  headerStyle();
});

var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if (is_safari) {
  $('body').addClass('is-safari');
}
